import React from "react";

import layoutStyles from "./footer.module.css";

export function routeHostByPref(pref) {
  return pref !== "chiba" ? "https://www.towa-housing.co.jp/" : "../";
}

const Footer = function ({ property }) {
  return (
    <footer className={`bg-dark mt-5 ${layoutStyles.nbFooter}`}>
      <div className="container">
        <div className="row">
          <div className=" col-md-3 col-sm-6">
            <div className={`${layoutStyles.footerInfoSingle}`}>
              <a
                className={`h2 ${layoutStyles.title}`}
                href={`${routeHostByPref(property.pref) + "/"}`}
              >
                屋根・外壁
              </a>
              <ul className="list-unstyled">
                <li>
                  <a href={`${routeHostByPref(property.pref) + "roof"}`}>
                    屋根工事
                  </a>
                </li>
                {/* <li>
                  <a
                    href={`${
                      routeHostByPref(property.pref) + "package-outerwall"
                    }`}
                  >
                    外壁塗装
                    <br />
                    パッケージ
                  </a>
                </li> */}
                <li>
                  <a href={`${routeHostByPref(property.pref) + "outerwall"}`}>
                    外壁塗装
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "flow"}`}>
                    お申込み
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "example"}`}>
                    施工事例
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className=" col-md-3 col-sm-6">
            <div className={`${layoutStyles.footerInfoSingle}`}>
              <span className={`h2 ${layoutStyles.title}`}>内装リフォーム</span>
              <ul className=" list-unstyled">
                <li>
                  <a href={`${routeHostByPref(property.pref) + "kitchen"}`}>
                    システムキッチン交換
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "unitbath"}`}>
                    ユニットバス交換
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "lavatory"}`}>
                    トイレ交換
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "wallpaper"}`}>
                    クロス張替え
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "tatami"}`}>
                    畳表替え
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "window"}`}>
                    窓交換・内窓設置
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-3 col-sm-6">
            <div className={`${layoutStyles.footerInfoSingle}`}>
              <a
                className={`h2 ${layoutStyles.title}`}
                href={`${routeHostByPref(property.pref) + "house/home.html"}`}
              >
                住宅取扱い
              </a>
              <ul className="list-unstyled">
                <li>
                  <a
                    href={`${
                      routeHostByPref(property.pref) + "house/sell.html"
                    }`}
                  >
                    買取かんたん査定
                  </a>
                </li>
                <li>
                  <a
                    href={`${
                      routeHostByPref(property.pref) + "house/used-list"
                    }`}
                  >
                    中古住宅
                  </a>
                </li>
                <li>
                  <a
                    href={`${
                      routeHostByPref(property.pref) + "house/rental-list"
                    }`}
                  >
                    賃貸
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className=" col-md-3 col-sm-6">
            <div className={`${layoutStyles.footerInfoSingle}`}>
              <a
                className={`h2 ${layoutStyles.title}`}
                href={`${routeHostByPref(property.pref) + "company"}`}
              >
                会社情報
              </a>
              <ul className=" list-unstyled">
                <li>
                  <a
                    href={`${
                      routeHostByPref(property.pref) + "company/#receiptarea"
                    }`}
                  >
                    受注エリア
                  </a>
                </li>
                <li>
                  <a
                    href={`${
                      routeHostByPref(property.pref) + "company/#map_towa"
                    }`}
                  >
                    所在地
                  </a>
                </li>
                <li>
                  <a href={`${routeHostByPref(property.pref) + "ask/#acquit"}`}>
                    免責事項
                  </a>
                </li>
                <li>
                  <a
                    href={`${routeHostByPref(property.pref) + "ask/#privacy"}`}
                  >
                    個人情報保護方針
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-sm-12 pt-2">
            <p>
              <span>
                千葉県八街市朝日139-17&emsp; TEL：043-497-4500&emsp;
                営業時間：9:30-17:30&emsp;定休日：毎週火・水曜日
              </span>
            </p>
            <p>
              <span>Copyright (C) Towa Housing Inc. All Rights Reserved.</span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
